import React, { useEffect } from 'react';
import ic_suspend from "assets/images/ic_suspend.svg";
import { func_datetime, func_validation, getObjectPropertyValue, isNumberValid, isStringEqual_caseInsensitive, isStringTrimNotEmpty } from 'functions';
import { Spinner } from 'components/loaders/Spinner';
import { useCustomSelector } from 'hooks';
import { Tooltip } from 'components/informational/Tooltip';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-solid-svg-icons';

export function useTableColumns({ 
    requestingSingleRowPos, setIsModalVisible, setSingleCOMDetail, 
    setIsSingleRequest, currentTabId, requestType
}) {
    const {
        userPermissions
    } = useCustomSelector("distributorPortal_userManagementReducers");

    function getColumn_comID() {
        let columnClassName = "columns__com-id";

        return {
            headerCellClassName: columnClassName,
            Header: "Com ID",
            id: "companyId",
            accessor: (currentTabId === "comList")? "comId": "ComId",
            bodyCellClassName: columnClassName + " align-items-center ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isNumberValid(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis d-flex align-items-center"}>{value_formatted}</div>
                );
            },
            width: 100
        }
    }

    function getColumn_comName() {
        let columnClassName = "columns__com-name flex-fill";

        return {
            headerCellClassName: columnClassName,
            Header: "COM Name",
            id: "comName",
            accessor: "comName",
            bodyCellClassName: columnClassName + " align-items-center ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumn_comEmail() {
        let columnClassName = "columns__com-email flex-fill";

        return {
            headerCellClassName: columnClassName,
            Header: "COM Email",
            id: "comEmail",
            accessor: "Email",
            bodyCellClassName: columnClassName + " align-items-center ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumn_action() {
        let columnClassName = "columns__action";

        return {
            headerCellClassName: columnClassName,
            Header: "Action",
            id: "action",
            accessor: "Trial",
            bodyCellClassName: columnClassName + " align-items-center ",
            Cell: (props) => {
                let rowIndex = props?.row?.index;

                if (!(userPermissions?.Dealer_ComInfo_Update)) return "";

                return (
                    <div className={"action__button d-flex align-items-center " +
                            // (isSuspended? "invisible ":"") +
                            ((requestingSingleRowPos.current == rowIndex)? "action__button_visible ":"")}
                        onClick={() => {
                            let data = props?.row? props.row: {};
                            setSingleCOMDetail(data);
                            setIsModalVisible(true);
                            setIsSingleRequest(true);
                        }}
                    >
                        {(requestingSingleRowPos.current == rowIndex)? ( 
                            <Spinner className={"button__spinner"} size={0} />
                        ):(<img
                            className={"button__icon"}
                            src={ic_suspend}
                        />)}
                        <span className={"button__text"}>{requestType.current == "COM Reactivation"? "Reactivate":"Activate"}</span>
                    </div>
                );
            },
        }
    }

    function getColumn_requester() {
        let columnClassName = "columns__requester flex-fill";

        return {
            headerCellClassName: columnClassName,
            Header: "Requester",
            id: "requester",
            accessor: "Requester",
            bodyCellClassName: columnClassName + " align-items-center ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumn_requestDate() {
        let columnClassName = "columns__request-date align-items-center";

        return {
            headerCellClassName: columnClassName,
            Header: "Request date",
            id: "requestDate",
            accessor: "RequestDate",
            bodyCellClassName: columnClassName,
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
                if (isStringTrimNotEmpty(value_formatted) && (value_formatted != "-")) 
                    value_formatted = func_datetime.convertDateTimeToLocal(value_formatted, "DD/MM/YYYY");
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumn_respondDate() {
        let columnClassName = "columns__respond-date align-items-center";

        return {
            headerCellClassName: columnClassName,
            Header: "Respond date",
            id: "respondDate",
            accessor: "UpdateDate",
            bodyCellClassName: columnClassName,
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
                if (isStringTrimNotEmpty(value_formatted) && (value_formatted != "-")) 
                    value_formatted = func_datetime.convertDateTimeToLocal(value_formatted, "DD/MM/YYYY");
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumns_requestReason() {
        let columnClassName = "columns__request-reason";
    
        return {
            headerCellClassName: columnClassName,
            Header: "Request Reason",
            id: "requestReason",
            accessor: "RequestReason",
            bodyCellClassName: columnClassName,
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <Tooltip
                        className={"w-100"}
                        targetContentClassName={"request-reason__content"}
                        target={(
                            <div className={"noWrap-text-ellipsis"}>
                                {value_formatted}
                            </div>
                        )}
                        tooltipContent={value_formatted}
                    />
                );
            },
            width: 300
        }
    }

    function getColumns_responseReason() {
        let columnClassName = "columns__response-reason";
    
        return {
            headerCellClassName: columnClassName,
            Header: "Response Reason",
            id: "responseReason",
            accessor: "ResponseReason",
            bodyCellClassName: columnClassName,
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <Tooltip
                        className={"w-100"}
                        targetContentClassName={"response-reason__content"}
                        target={(
                            <div className={"noWrap-text-ellipsis"}>
                                {value_formatted}
                            </div>
                        )}
                        tooltipContent={value_formatted}
                    />
                );
            },
            width: 300
        }
    }

    function getColumn_status() {
        let columnClassName = "columns__status flex-fill";

        return {
            headerCellClassName: columnClassName + " ",
            Header: (currentTabId == "comList")? "Status": "Request Type",
            id: "status",
            accessor: "RequestName",
            bodyCellClassName: columnClassName + " align-items-center ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = "-", statusIconColor = "";
                if (currentTabId == "comList") {
                    let data = props?.row?.original;
                    let isTrial = data?.Trial;

                    statusIconColor = isTrial? "icon__trial ":"icon__active ";
                    value_formatted = isTrial? "Trial": "Active";
                }
                else {
                    switch (value) {
                        case "ReactiveComId": value_formatted = "COM Reactivation"; break;
                        case "TrialToBillableCom": value_formatted = "Trial Activation"; break;
                    }
                }

                return (
                    <div className={"noWrap-text-ellipsis"}>
                        {isStringTrimNotEmpty(statusIconColor)? 
                            (<FontAwesomeIcon 
                                className={"status__icon " + statusIconColor} 
                                icon={faCircle}
                            />
                        ):""}
                        <span>{value_formatted}</span>
                    </div>
                );
            },
        }
    }

    let columns = [
        getColumn_comID()
    ];

    switch (currentTabId) {
        case "comList":
            columns.push(getColumn_comName());
            columns.push(getColumn_comEmail());
            // columns.push(getColumn_status());
            columns.push(getColumn_action());
            break;
        case "pending":
            columns.push(getColumn_requester());
            // columns.push(getColumn_comName());
            // columns.push(getColumn_comEmail());
            columns.push(getColumn_status());
            columns.push(getColumn_requestDate());
            columns.push(getColumns_requestReason());
            break;
        case "activated": 
            columns.push(getColumn_requester());
            columns.push(getColumn_status());
            columns.push(getColumn_requestDate());
            columns.push(getColumn_respondDate());
            columns.push(getColumns_requestReason());
            columns.push(getColumns_responseReason());
            break;
        case "rejected":
            columns.push(getColumn_requester());
            columns.push(getColumn_status());
            columns.push(getColumn_requestDate());
            columns.push(getColumn_respondDate());
            columns.push(getColumns_requestReason());
            columns.push(getColumns_responseReason());
            break;
    }

    return columns;
}